var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_145_123521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18V18H0V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 0V2.25L11.3203 9L18 15.5742V18H15.6445L8.92969 11.3906L2.39062 18H0V15.6094L6.53906 9.03516L0 2.60156V0H2.17969L8.92969 6.60938L15.4688 0H18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46875 11.3906L6.85547 12.5859L1.47656 18H0V17.8945L6.46875 11.3906ZM10.8281 10.9688L12.7266 11.25L18 16.418V18L10.8281 10.9688ZM18 0L11.25 6.89062L11.1094 5.34375L16.3828 0H18ZM0 0.0351562L6.78516 6.67969L4.71094 6.39844L0 1.72266V0.0351562Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 0V18H11.8125V0H6.1875ZM0 6.1875V11.8125H18V6.1875H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.3125V10.6875H18V7.3125H0ZM7.3125 0V18H10.6875V0H7.3125Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_145_123521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.d22279669637f59aa6422046c300d8a9.svg";
export { ForwardRef as ReactComponent };